<eiq-card>
  <div slot="content" class="eiq-section-card" [attr.id]="sectionId() || null">
    <div class="eiq-section-card__header">
      <div class="eiq-section-card__header-row">
        <div class="eiq-section-card__header-heading">
          <eiq-icon-badge [icon$]="icon()" [color$]="color()" [size$]="'small'" />

          <div class="eiq-section-card__header-heading-text">
            <span class="text__lg fw__600">{{ heading$() }}</span>
            @if (subtitle()) {
              <span class="text__md fw__400 caption">{{ subtitle() }}</span>
            }
          </div>
        </div>

        @if (valid()) {
          <eiq-badge text="Complete" [color]="'success'" [icon]="faCircleCheck" [height]="'medium'" />
        }
      </div>

      <div class="eiq-section-card__header-actions">
        <ng-content select="[slot=actions]"></ng-content>
      </div>
    </div>

    <div class="eiq-section-card__content">
      <ng-content></ng-content>
    </div>
  </div>
</eiq-card>
